import { environmentHttpClient } from "../httpClient";

export type RequestEmergencyAdminAccessModel = {
	userName: string;
};

export type SignInModel = {
	userName: string;
	password: string;
	returnUrl: string | null;
};

export type SignInResult =
	{
		wasSuccessful: false;
	}
	|
	{
		wasSuccessful: true;
		redirectUrl: string;
	};

export function requestEmergencyAdminAccess(
	model: RequestEmergencyAdminAccessModel,
	signal?: AbortSignal
): Promise<void> {
	return environmentHttpClient.post<void>(
		"AdminPage/RequestEmergencyAdminAccess",
		model,
		{ signal }
	);
}

export function signIn(
	model: SignInModel,
	signal?: AbortSignal
): Promise<SignInResult> {
	return environmentHttpClient.post<SignInResult>(
		"AdminPage/SignIn",
		model,
		{ signal }
	);
}

